import React from 'react';
import { openReportInNewTab } from '@/reports/index';
import { Link as _Link, styled } from '@/theme/index';
import { formatPhone } from '@/utils/index';

const PropertyLink = styled(_Link)({
  cursor: 'pointer',
  textDecoration: 'none',
  fontSize: '1rem',
  fontWeight: 600,
  ':hover': {
    textDecoration: 'underline',
  },
});

interface PhoneNumberLinksProps {
  numbers: string[];
  baseUrl: string;
}

export const PhoneNumberLinks: React.FC<PhoneNumberLinksProps> = ({
  numbers,
  baseUrl,
}) => {
  const handleClick = (phoneNumber: string) => {
    openReportInNewTab(
      { phone: phoneNumber || '', searchType: 'phone' },
      baseUrl
    );
  };

  const filteredNumbers = numbers.filter((link) => link !== '');

  if (filteredNumbers.length === 0) {
    return null;
  }

  return (
    <div>
      {filteredNumbers.map((number, i) => (
        <React.Fragment key={i}>
          {i > 0 && ', '}
          <PropertyLink onClick={() => handleClick(number)}>
            {formatPhone(number)}
          </PropertyLink>
        </React.Fragment>
      ))}
    </div>
  );
};
